<template>
    <div class="cashout-request-cont">
        <div class="cashout-request-cont__return-arrow">
            <button-back class="asset-item__return-back"></button-back>
        </div>
        <cashout-request-header class="cashout-request-cont__header">
        </cashout-request-header>
        <cashout-request-body-text
            class="cashout-request-cont__body-text"
        ></cashout-request-body-text>
        <cashout-request-coyn-balance
            class="cashout-request-cont__coyn-balance"
            :min-coyns-amount="getCashbackSettings.minCoynsAmount"
            :exchange-rate="exchangeRate"
        ></cashout-request-coyn-balance>
        <cashout-request-form
            :exchange-rate="exchangeRate"
            class="cashout-request-cont__form"
        >
        </cashout-request-form>
    </div>
</template>
<script>
import cashoutRequestHeader from './sections/request_cashback_header';
import cashoutRequestBodyText from './sections/request_cashback_body-text';
import cashoutRequestCoynBalance from './sections/request_cashback_coyn-balance';
import cashoutRequestForm from './sections/request_cashback_form';
import { mapActions, mapGetters } from 'vuex';
import ButtonBack from '@/components/common/ButtonBack.vue';
import { JOIN_CREATORS_CLUB_PAGE_NAME } from '@/router/pageNameConstants.js';
import { addInfoNotification } from '../../lib/notifications';
import store from '@/store';
export default {
    name: 'RequestCashback',
    components: {
        cashoutRequestHeader,
        cashoutRequestBodyText,
        cashoutRequestCoynBalance,
        cashoutRequestForm,
        ButtonBack,
    },
    data() {
        return {
            exchangeRate: 0,
        };
    },

    computed: {
        ...mapGetters('cashback', ['getCashbackSettings']),
    },
    mounted: async function() {
        await this.fetchCashbackSettings();
        let rateValue = this.getCashbackSettings.oneCoynExchangeRate;
        let decPlaces = this.getCashbackSettings
            .oneCoynExchangeRateDecimalPlaces;
        this.getRate(rateValue, decPlaces);
    },
    methods: {
        ...mapActions('cashback', ['fetchCashbackSettings']),

        getRate(rateValue, decPlaces) {
            this.exchangeRate = rateValue / Math.pow(10, decPlaces);
        },
    },
    beforeRouteEnter(to, from, next) {
        if (store.getters['creator/getSubscription'] == false) {
            addInfoNotification('Only subscribers can request commission!');
            next({ name: JOIN_CREATORS_CLUB_PAGE_NAME });
            return;
        }
        next();
    },
};
</script>

<style scoped lang="scss">
.cashout-request-cont {
    @include main-grid-container;
    padding-top: 10%;

    &__return-arrow {
        grid-column: col-start 3 / 4;
        grid-row: 1;
        margin-bottom: 50px;
        display: flex;

        @media (min-width: $xxs-up) and (max-width: $lg-up) {
            grid-column: col-start 2 / 6;
        }

        @media (min-width: 900px) and (max-width: $xl-up) {
            grid-column: col-start 3 / 11;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 30px 0;
        }
    }

    &__header {
        grid-column: col-start 3 / 11;
        grid-row: 2;

        @media (max-width: 900px) {
            grid-column: col-start 2 / 12;
            grid-row: 2;
        }

        @media (max-width: $xs-up) {
            grid-column: col-start 1 / 13;
            grid-row: 2;
            margin: 5%;
        }
    }

    &__body-text {
        grid-column: col-start 3 / 11;
        grid-row: 3;

        @media (max-width: 900px) {
            grid-column: col-start 2 / 12;
            grid-row: 3;
        }

        @media (max-width: $xs-up) {
            grid-column: col-start 1 / 13;
            grid-row: 3;
        }
    }

    &__coyn-balance {
        grid-column: col-start 3 / 11;
        grid-row: 4;

        @media (max-width: 900px) {
            grid-column: col-start 2 / 12;
            grid-row: 4;
        }

        @media (max-width: $xs-up) {
            grid-column: col-start 1 / 13;
            grid-row: 4;
        }
    }
    &__form {
        margin-top: 10%;
        grid-column: col-start 3 / 11;
        grid-row: 5;
        @media (max-width: 900px) {
            grid-column: col-start 2 / 12;
            grid-row: 5;
        }

        @media (max-width: $xs-up) {
            grid-column: col-start 1 / 13;
            grid-row: 5;
        }
    }
}
</style>
